import { medicaidInsurersCollection } from '../collections/collections/insurer'
import { FieldTypes } from '../constants'
import { CustomElement } from '../editor/types'
import {
  BaseInsuranceCoverage,
  CheckboxField,
  DateField,
  FieldMap,
  IdField,
  InsuranceProvider,
  PhoneField,
  TextField,
} from '../types'
import { addressToString } from '../utils/data'
import { makeAllFieldsOptional } from '../utils/fields'
import { signOnBirthLocationField } from './pregnancy'
import { addressField } from './shared'
import { addCondition } from './utils'

export const patientPhoneField: PhoneField = {
  type: FieldTypes.PHONE,
  labels: [{ text: 'What is your phone number (as listed with your insurer)?' }],
  placeholder: 'Phone Number',
}

const initialServiceDateField: DateField = {
  type: FieldTypes.DATE,
  optional: true,
  labels: [{ text: 'When did you first consult with your midwife?' }],
  placeholder: 'Initial date of service (consultation)',
}

const initialPrenatalVisitDateField: DateField = {
  type: FieldTypes.DATE,
  optional: true,
  labels: [
    {
      text: 'When was your first prenatal visit with your midwife? (Could be in the future)',
    },
  ],
  placeholder: 'Date of first prenatal visit',
}

const homeAddressIsSameAsPatientAddressField: CheckboxField = {
  type: FieldTypes.CHECKBOX,
  placeholder: 'Home address same as primary coverage address',
}

const baseHomeAddressField: FieldMap = {
  name: 'Home Address',
  children: addressField.children,
}
const homeAddressField: FieldMap = {
  ...baseHomeAddressField,
  condition: v => !v?.homeAddressSameAsPatientAddress,
}

export const medicaidInsurerIdField: IdField<InsuranceProvider> = {
  labels: [
    {
      text: 'Who is your secondary insurer? (Medicaid)',
    },
  ],
  type: FieldTypes.ID,
  condition: v => !!v?.isMedicaid,
  collection: medicaidInsurersCollection,
  placeholder: 'Insurance Provider (Medicaid)',
  allowOther: true,
}

const employerNameField: TextField = {
  type: FieldTypes.TEXT,
  optional: true,
  placeholder: 'Employer Name',
}

const employerAddressField: FieldMap = makeAllFieldsOptional({
  ...addressField,
  condition: v => !!v?.name,
  name: 'Employer Address',
})

const employerField: FieldMap = {
  name: 'Employer Info',
  optional: true,
  children: {
    name: employerNameField,
    address: employerAddressField,
  },
}

export const newSignOnFields: FieldMap = {
  name: 'Sign-on Form',
  children: {
    birthType: signOnBirthLocationField,
    // address: patientAddressField,
    homeAddressSameAsPatientAddress: homeAddressIsSameAsPatientAddressField,
    homeAddress: homeAddressField,
    phone: patientPhoneField,
    initialServiceDate: initialServiceDateField,
    initialPrenatalVisitDate: {
      ...initialPrenatalVisitDateField,
      placeholder: 'Date of first prenatal visit',
    },
    // hasPartner: {
    //   type: FieldTypes.BOOLEAN,
    //   placeholder: 'Patient has Partner',
    //   labels: [{ text: 'Do you have a partner?' }],
    // },
    // partnerContact: partnerContactField,
    employer: employerField,
  },
}

// displays the primary coverage address for reference
export const getSignOnFields = (primaryCoverage: BaseInsuranceCoverage | undefined | null) => {
  const primaryAddress = primaryCoverage?.address
  let children: FieldMap['children'] = {
    birthType: signOnBirthLocationField,
  }
  if (primaryAddress) {
    children = {
      ...children,
      primaryAddressView: {
        style: {
          width: '100%',
          lineHeight: '1.4rem',
        },
        info: true,
        name: 'Primary Coverage Address',
        data: [
          {
            type: 'span',
            children: [
              { text: 'Your primary coverage address is:\n', header: true, color: '#555' },
              {
                text: addressToString(primaryAddress, true),
              },
            ],
          },
        ] as CustomElement[],
      },
      homeAddressSameAsPatientAddress: homeAddressIsSameAsPatientAddressField,
    }
  }
  children = {
    ...children,
    homeAddressField: primaryAddress
      ? addCondition(baseHomeAddressField, v => !v?.homeAddressSameAsPatientAddress)
      : baseHomeAddressField,
    initialServiceDate: initialServiceDateField,
    initialPrenatalVisitDate: {
      ...initialPrenatalVisitDateField,
      placeholder: 'Date of first prenatal visit',
    },
    // hasPartner: {
    //   type: FieldTypes.BOOLEAN,
    //   placeholder: 'Patient has Partner',
    //   labels: [{ text: 'Do you have a partner?' }],
    // },
    // partnerContact: partnerContactField,
    employer: employerField,
  }
  return {
    ...newSignOnFields,
    children,
  }
}

export const signOnFields: FieldMap = {
  ...newSignOnFields,
  children: {
    ...newSignOnFields.children,
    // policyOwnerRelationship: policyOwnerRelationshipField,
    // selfPolicyOwnerDetails,
    // partnerPolicyOwnerDetails,
    // policyOwnerInfo: policyOwnerField,
    // hasSecondaryCoverage: {
    //   type: FieldTypes.BOOLEAN,
    //   labels: [{ text: 'Do you have secondary coverage?' }],
    //   placeholder: 'Secondary Coverage',
    // },
    // secondaryCoverageDetails: {
    //   name: 'Secondary Coverage Details',
    //   condition: (v) => v?.hasSecondaryCoverage,
    //   children: {
    //     policyOwnerRelationship: policyOwnerRelationshipField,
    //     selfPolicyOwnerDetails,
    //     partnerPolicyOwnerDetails,
    //     isMedicaid: {
    //       type: FieldTypes.BOOLEAN,
    //       placeholder: 'Is your secondary coverage through Medicaid?',
    //     },
    //     insurerId: insuranceProviderField,
    //     medicaidInsurerId: medicaidInsuranceProviderField,
    //     memberId: {
    //       type: FieldTypes.TEXT,
    //       placeholder: 'Member ID for Secondary Coverage',
    //     },
    //     initialServiceDate: {
    //       ...initialServiceDateField,
    //       placeholder: 'Initial Date of Service (Secondary Coverage)',
    //     },
    //     initialPrenatalVisitDate: {
    //       ...initialPrenatalVisitDateField,
    //       placeholder: 'Date of First Prenatal Visit (Secondary Coverage)',
    //     },
    //     ...policyOwnerFields,
    //   },
    // } as FieldMap,
  },
}
